// extracted by mini-css-extract-plugin
export default {"main":"app_main__Mk+bc","homePage":"app_homePage__GvKJD"};